import { Avatar } from "@mui/material";
import dayjs from "dayjs";
import { useAppDispatch, useAppSelector } from "services/redux/store";
import { Breadcrumb, ConfirmDeleteModal, MyModal, customToaster } from "ui";
import { BreadcrumbObject } from "ui/files/core/Breadcrumb";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import { removeNoti } from "services/redux/notifications";

import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { NotiObj, NotiViewObj } from "utils/types/general.types";
import { Link } from "react-router-dom";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import PhoneIphoneRoundedIcon from "@mui/icons-material/PhoneIphoneRounded";
import { useState } from "react";
import phonePNG from "assets/images/resizeiphone.png";
import { shortUserName } from "utils/helpers/shortUserName";
import { notiViewData } from "assets/data/notiData";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import EditNotiForm from "components/files/notifications/EditNotiForm";

const NotificationDetails = () => {
    const notiData = useAppSelector(
        (state) => state.notifications.notifications
    );
    const dispatch = useAppDispatch();

    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        },
        {
            path: "/notifications",
            text: "Notifications"
        }
    ];

    const [deleteID, setDeleteID] = useState<string | number>("");
    const [openSingleModal, setOpenSingleModal] = useState(false);

    const handleDelete = (id: string | number) => {
        setDeleteID(id);
        setOpenSingleModal(true);
        // dispatch(removeNoti(id));
    };

    const handleSend = (id: string | number) => {
        console.log("sending notification: ", id);
    };

    const columns: GridColDef[] = [
        { field: "title", headerName: "Title", flex: 1, minWidth: 100 },
        { field: "message", headerName: "Message", flex: 5, minWidth: 200 },
        { field: "notiType", headerName: "Type", flex: 1, minWidth: 70 },
        {
            field: "media",
            headerName: "Media",
            renderCell: (params) => <Avatar src={params.value} />,
            flex: 1,
            minWidth: 70
        },
        {
            field: "createDate",
            headerName: "Create Date",
            renderCell: (params) => (
                <span>{dayjs(params.value).format("YYYY-MM-DD")}</span>
            ),
            flex: 2,
            minWidth: 100
        },
        {
            field: "scheduleDate",
            headerName: "Schedule Date",
            renderCell: (params) => (
                <span>{dayjs(params.value).format("YYYY-MM-DD HH:mm A")}</span>
            ),
            flex: 2,
            minWidth: 150
        },
        { field: "status", headerName: "Status", flex: 1, minWidth: 70 },
        { field: "reminder", headerName: "Reminder", flex: 1, minWidth: 70 },
        {
            field: "id",
            headerName: "Actions",
            renderCell: (params) => (
                <div className="flex justify-center items-center gap-3 w-full">
                    <div
                        onClick={() => handleOpenView(params.value)}
                        className="w-fit cursor-pointer"
                    >
                        <PhoneIphoneRoundedIcon
                            className="dark:text-white"
                            fontSize="small"
                        />
                    </div>
                    <div
                        onClick={() => handleSend(params.value)}
                        className="w-fit cursor-pointer"
                    >
                        <SendRoundedIcon
                            className="dark:text-white"
                            fontSize="small"
                        />
                    </div>

                    <div
                        onClick={() => handleSelectEvent(params.value)}
                        className="w-fit cursor-pointer"
                    >
                        <EditIcon
                            className="dark:text-white"
                            fontSize="small"
                        />
                    </div>

                    <div
                        onClick={() => handleDelete(params.value)}
                        className="w-fit cursor-pointer"
                    >
                        <DeleteForeverIcon
                            className="dark:text-white"
                            fontSize="small"
                        />
                    </div>
                </div>
            ),
            flex: 2,
            minWidth: 150,
            align: "center",
            headerAlign: "center"
        }
    ];

    const [openView, setOpenView] = useState(false);
    const [viewNoti, setViewNoti] = useState<NotiObj>();

    const handleOpenView = (id: string | number) => {
        const noti = notiData.filter((n) => n.id === id)[0];
        if (noti) {
            setViewNoti(noti);
            setOpenView(true);
        }
    };

    // new columns def
    const columns2: GridColDef[] = [
        {
            field: "user",
            headerName: "User Name",
            flex: 1,
            minWidth: 100,
            renderCell: (params) => (
                <Link to={`/users/view/${params.value.id}`}>
                    {params.value.userName}
                </Link>
            )
        },
        {
            field: "media",
            headerName: "Media",
            renderCell: (params) => (
                <div style={{ paddingTop: "5px" }}>
                    <Avatar src={params.value} />
                </div>
            ),
            flex: 1,
            minWidth: 70
        },
        { field: "status", headerName: "Status", flex: 1, minWidth: 70 }
    ];

    const sentData: NotiViewObj[] = notiViewData.filter(
        (i) => i.status === "sent"
    );
    const viewedData: NotiViewObj[] = notiViewData.filter(
        (i) => i.status === "viewed"
    );

    // edit noti form

    const mode = useAppSelector((state) => state.site.mode);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [editNoti, setEditNoti] = useState<NotiObj>();
    const handleSelectEvent = (id: string | number) => {
        const noti = notiData.filter((i) => i.id === id)[0];
        setEditNoti(noti);
        setOpenEditModal(true);
    };

    return (
        <>
            <section className="w-full h-full flex flex-col relative">
                <div className="w-full h-full flex relative  overflow-auto">
                    <div className="w-full flex flex-col">
                        <div className="w-full text-center">
                            {/* <Breadcrumb
                                breadcrumb={breadcrumb}
                                currentPath="Details"
                            /> */}
                            <div className="flex justify-between items-center w-full text-center px-10 pt-2">
                                <Link to="/notifications">
                                    <ArrowBackIosNewRoundedIcon
                                        fontSize="small"
                                        className="dark:text-white"
                                    />
                                </Link>
                                <Breadcrumb
                                    breadcrumb={breadcrumb}
                                    currentPath="Details"
                                />
                            </div>
                            <h1 className="font-medium text-lg dark:text-white py-4">
                                Push Notification Details
                            </h1>
                        </div>
                        <div className="w-full items-center flex flex-col gap-3 px-10 ">
                            <div style={{ height: 165, width: "100%" }}>
                                <DataGrid
                                    rows={[notiData[0]]}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                page: 0,
                                                pageSize: 1
                                            }
                                        }
                                    }}
                                    // pageSizeOptions={[1]}
                                    getRowId={(row: NotiObj) => row.id}
                                    getRowClassName={(params) =>
                                        params.indexRelativeToCurrentPage %
                                            2 ===
                                        0
                                            ? "even"
                                            : "odd"
                                    }
                                    // checkboxSelection
                                />
                            </div>
                        </div>

                        <div className="w-full justify-between items-center flex flex-col md:flex-row  gap-10 md:gap-3 px-10 py-5">
                            <div
                                style={{ height: 400, width: "100%" }}
                                className="mb-10 md:mb-0"
                            >
                                <h1 className="dark:text-white font-medium py-2">
                                    Pending Total:{" "}
                                    <span className="font-bold">
                                        {sentData.length}
                                    </span>
                                </h1>
                                <DataGrid
                                    rows={sentData}
                                    columns={columns2}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                page: 0,
                                                pageSize: 5
                                            }
                                        }
                                    }}
                                    pageSizeOptions={[5, 15, 30, 50, 100]}
                                    getRowId={(row: NotiViewObj) => row.id}
                                    getRowClassName={(params) =>
                                        params.indexRelativeToCurrentPage %
                                            2 ===
                                        0
                                            ? "even"
                                            : "odd"
                                    }
                                    // checkboxSelection
                                />
                            </div>

                            <div style={{ height: 400, width: "100%" }}>
                                <h1 className="dark:text-white font-medium py-2">
                                    Viewed Total:{" "}
                                    <span className="font-bold">
                                        {viewedData.length}
                                    </span>
                                </h1>
                                <DataGrid
                                    rows={viewedData}
                                    columns={columns2}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                page: 0,
                                                pageSize: 5
                                            }
                                        }
                                    }}
                                    pageSizeOptions={[5, 15, 30, 50, 100]}
                                    getRowId={(row: NotiViewObj) => row.id}
                                    getRowClassName={(params) =>
                                        params.indexRelativeToCurrentPage %
                                            2 ===
                                        0
                                            ? "even"
                                            : "odd"
                                    }
                                    // checkboxSelection
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ConfirmDeleteModal
                text="Delete Notification"
                open={openSingleModal}
                setOpen={setOpenSingleModal}
                handleDelete={() => dispatch(removeNoti(deleteID))}
            />
            <MyModal
                open={openView}
                setOpen={setOpenView}
                className="preview-noti-modal"
            >
                <div className="flex flex-col justify-center items-center gap-3">
                    <h1 className="dark:text-white font-bold ">
                        Preview Push Notification
                    </h1>
                    <div className="relative">
                        <img src={phonePNG} alt="preview notification image" />
                        {viewNoti && (
                            <div className="preview-img-div flex justify-between items-center gap-3  px-3 py-2">
                                <div className="flex flex-col gap-3">
                                    <h1>{viewNoti.title}</h1>
                                    <p>{shortUserName(viewNoti.message, 30)}</p>
                                </div>
                                <Avatar src={viewNoti.media} />
                            </div>
                        )}
                    </div>
                </div>
            </MyModal>
            <MyModal open={openEditModal} setOpen={setOpenEditModal}>
                <div className="px-4 py-4">
                    <EditNotiForm
                        showTitle
                        noti={editNoti}
                        setEditNoti={setEditNoti}
                        handleSave={() => {
                            setOpenEditModal(false);
                            customToaster(
                                "success",
                                "Push Notificatopn Updated",
                                mode
                            );
                        }}
                        handleClose={() => {
                            setOpenEditModal(false);
                            customToaster(
                                "info",
                                "Push Notificatopn Updated",
                                mode
                            );
                        }}
                        handleCloseModal={!openEditModal}
                    />
                </div>
            </MyModal>
        </>
    );
};

export default NotificationDetails;
